import React from 'react'

import LoadingSpinner from '@cinch/oxd-components/loading-spinner/src'

import * as styles from './spinner.module.css'

const PageSpinner: React.FC = () => (
  <div className={styles.spinner}>
    <LoadingSpinner size={32} />
  </div>
)

export default PageSpinner
